import {
	differenceInDays,
	differenceInHours,
	differenceInMinutes,
	differenceInSeconds,
	differenceInWeeks,
	format,
	isToday,
	isValid,
	isYesterday,
	parseISO,
} from 'date-fns';

export const formatDateToShortDate = (dateString: string): string => {
	const date = new Date(dateString); // 2024-08-12T04:04:00

	const month = date.getMonth() + 1; // Adding 1 because months are zero-indexed
	const day = date.getDate();

	// Add a leading zero if month or day is less than 10 to have the format MM/DD
	const formattedMonth = month < 10 ? '0' + month : month;
	const formattedDay = day < 10 ? '0' + day : day;

	return `${formattedMonth}/${formattedDay}`; // formart returned -> 08/12
};

export const formatTimeWithToday = (dateString: string): string | undefined => {
	if (!dateString) return;
	const todayDate = new Date(dateString);

	const formattedTime = format(todayDate, 'h:mm a');

	const formattedDate = isToday(todayDate)
		? `Today ${formattedTime}`
		: isYesterday(todayDate)
		? `Yesterday ${formattedTime}`
		: format(todayDate, 'MMM d, h:mm a');

	return formattedDate; // Today 9:31 AM | Yesterday 9:31 AM | Sep 12, 9 31 AM
};

export const formatRelativeTimeAbbreviated = (isoDate: string) => {
	const date = parseISO(isoDate);
	const now = new Date();

	const seconds = differenceInSeconds(now, date);
	if (seconds < 60) return `${seconds}s`;

	const minutes = differenceInMinutes(now, date);
	if (minutes < 60) return `${minutes}m`;

	const hours = differenceInHours(now, date);
	if (hours < 24) return `${hours}h`;

	const days = differenceInDays(now, date);
	if (days < 7) return `${days}d`;

	const weeks = differenceInWeeks(now, date);
	return `${weeks}w`;
};

export const formatDateWithin24h = (date: string): string => {
	const dateObj = parseISO(date);
	const now = new Date();

	// Verify if the date is today
	const isToday =
		dateObj.getDate() === now.getDate() &&
		dateObj.getMonth() === now.getMonth() &&
		dateObj.getFullYear() === now.getFullYear();

	let display;
	if (isToday) {
		// Show "4:22 pm"
		display = format(dateObj, 'h:mm aa');
	} else {
		// Show date (dd/MM/yyyy)
		display = format(new Date(date), 'MMM d');
	}

	return display;
};

export const getFormattedTableDate = (paramDate: string) => {
	const date = new Date(paramDate);
	const year = date.getUTCFullYear();
	const month = String(date.getUTCMonth() + 1).padStart(2, '0');
	const day = String(date.getUTCDate()).padStart(2, '0');

	return `${month}-${day}-${year}`;
};

export const formatUTCToLocal = (isoDate: string): string => {
	if (!isoDate) return '';

	const date = new Date(isoDate);
	const month = String(date.getUTCMonth() + 1).padStart(2, '0');
	const day = String(date.getUTCDate()).padStart(2, '0');
	const year = date.getUTCFullYear();
	return `${month}/${day}/${year}`;
};

export const formatReceivedDate = (date: string): string | null => {
	const parsed = parseISO(date);
	if (!isValid(parsed)) return null;
	return `Received ${format(parsed, 'MMM d, yyyy')}`;
};
